"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startRumEventBridge = startRumEventBridge;
const browser_core_1 = require("@datadog/browser-core");
function startRumEventBridge(lifeCycle) {
    const bridge = (0, browser_core_1.getEventBridge)();
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, (serverRumEvent) => {
        bridge.send('rum', serverRumEvent);
    });
}
//# sourceMappingURL=startRumEventBridge.js.map